<template>
  <b-modal id="modalChooseUser" ref="modalChooseUser" @shown="modalShown" hide-footer size="lg">
    <b-row>
      <b-col>
        <md-field>
          <label>{{$t('Type to Search')}}</label>
          <md-input v-model="filter" @update="filterChanged" @keypress="currentPage = 1"></md-input>
        </md-field>
      </b-col>
    </b-row>

    <basic-table
      v-if="allUsers"
      :items="allUsers"
      :fields="fields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      @Filtred="Filtred"
      @RowSelected="rowClickHandler"
      @onRowDoubleClick="onRowDoubleClick"
      v-model="totalRows"
      isEdit="false"
      isDelete="false"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <modal-ok-cancel @save="select" @cancel="hideForm" buttonSaveLabel="Ok" size="lg"/>
  </b-modal>
</template>

<script>
export default {
  props: {
    tv24Users: Array
  },
  data () {
    return {
      selected: null,
      fields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'basic_account', label: this.$i18n.t('Basic account'), sortable: true },
        { key: 'full_name', label: this.$i18n.t('FullName'), sortable: true },
        { key: 'email', label: this.$i18n.t('Email') },
        { key: 'balance', label: this.$i18n.t('Balance'), sortable: true }
      ],
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    onRowDoubleClick (item, index, event) {
      if (this.selected) {
        this.selected._rowVariant = ''
      }
      this.selected = item
      this.$set(this.selected, '_rowVariant', 'info')
      this.select()
    },
    select () {
      if (!this.selected) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select user'), 'Error')
        return
      }
      this.$emit('addUser', this.selected)
      this.hideForm()
    },
    hideForm () {
      this.$bvModal.hide('modalChooseUser')
    },
    rowClickHandler (row) {
      if (this.selected) {
        this.selected._rowVariant = ''
      }
      this.selected = row
      this.$set(this.selected, '_rowVariant', 'info')
    },
    filterChanged (value) {
      this.filter = value
      this.currentPage = 1
    },
    paginationChanged (value) {
      this.perPage = value
    },
    modalShown () {
      this.$store.dispatch('Users/GET_ALL_USERS')
    }
  },
  computed: {
    allUsers () {
      let tmp = this.$store.getters['Users/ALL_USERS']

      if (!this.tv24Users) {
        return tmp
      }

      return tmp.filter(item => {
        for (let el of this.tv24Users) {
          if (el.provider_uid === String(item.user_id)) {
            return false
          }
        }
        return true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/formUsers.vue